// import {
//   ClientResponseOpts,
//   ThemeProvider,
// } from "@tuteria/shared-lib/dist/static_lib.mjs";
import { ClientResponseOpts } from "@tuteria/shared-lib/src/_new_/features/request-flow/admin/ClientResponseOpts";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";

export function unMountsendWhatsappMessageToClient(id: string) {
  ReactDOM.unmountComponentAtNode(document.getElementById(id));
}

type Props = {
  handleClosingModal: () => void;
  loadMessages: () => Promise<{
    messages: {
      title: string;
      message: string;
      requires_id?: boolean;
      getMessage?: (id: string) => Promise<string>;
    }[];
    params: any;
  }>;
};

const Component = ({ loadMessages, handleClosingModal }: Props) => {
  return (
    <ClientResponseOpts
      handleClosingModal={handleClosingModal}
      loadMessages={loadMessages}
      // onClose={onClose}
    />
  );
};

type Payload = {
  slug: string;
  type?: string;
  request_id?: string;
  tutor_id?: string;
  agent_name?: string;
  fetchMessages: (
    slug: string,
    request_id?: string,
    agent_name?: string
  ) => Promise<
    {
      title: string;
      message: string;
      getMessage?: (id: string) => Promise<string>;
    }[]
  >;
};

export function sendWhatsappMessageToClient(
  payload: Payload,
  id: string,
  urls: {},
  callback: (...args: any[]) => void
) {
  function loadMessages() {
    if (payload.type === "tutor") {
      const { tutor_id, request_id, agent_name } = payload;
      return payload.fetchMessages(tutor_id, request_id, agent_name);
    }
    return payload.fetchMessages(payload.slug);
  }

  function onClose() {
    unMountsendWhatsappMessageToClient(id);
  }

  ReactDOM.render(
    <ThemeProvider>
      <Component
        {...{
          loadMessages,
          handleClosingModal: onClose,
        }}
      />
    </ThemeProvider>,
    document.getElementById(id)
  );
}
